import { Button, Dialog, DialogActions, DialogContent, IconButton, styled, Typography } from '@mui/material';
import dataUpdatedIcon from '../../assets/images/data-updated-icon.svg';

const DialogTitleWrapper = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '12px',
  marginTop: '36px',
});

interface StatuteDeleteModalProps {
  open: boolean;
  onDone: () => void;
  statuteList?: string[] | null;
}

export function StatuteDeleteModal({ open, onDone, statuteList }: StatuteDeleteModalProps) {
  return (
    <Dialog open={open} sx={{ zIndex: 999 }} maxWidth='xs' fullWidth>
      <DialogTitleWrapper>
        <IconButton size='large' disabled sx={{ background: '#FEEBCB !important', color: '#ED8936 !important' }}>
          <img src={dataUpdatedIcon} alt='Data updated icon' width={36} height={36} />
        </IconButton>
        <Typography sx={{ fontSize: '24px', fontWeight: 'bold', color: 'primary.main' }}>Data Updated</Typography>
      </DialogTitleWrapper>
      <DialogContent sx={{ marginBottom: '24px' }}>
        <Typography sx={{ textAlign: 'center', fontSize: '14px' }}>
          Statute{statuteList && statuteList.length > 1 ? 's' : ''} <b>{statuteList?.join(', ')}</b> associated with
          this case {statuteList && statuteList.length > 1 ? 'have' : 'has'} been deleted from the system. This may
          impact some of the disparity calculations.
        </Typography>
      </DialogContent>
      <DialogActions
        sx={{
          display: 'flex',
          justifyContent: 'center',
          paddingX: '20px',
          paddingBottom: '20px',
        }}
      >
        <Button sx={{ width: 'calc(50% - 10px)' }} disableElevation variant='contained' onClick={onDone}>
          Acknowledge
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default StatuteDeleteModal;
